module.exports = import("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0");;